import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class AddIntegrationCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IAddIntegrationParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'api';
  public override setParameters(parameters: IAddIntegrationParameters) {
    this._commandBody = parameters;
  }
}

export interface IAddIntegrationParameters extends ICommandParameters {
  carrierAccountId: number;
  contractorAccountId: null;
  applicationName: string;
  description: string;
  userName: string;
  password: string;
  enabled: boolean;
  blocked: boolean;
  securityRoleName: string;
}
